export const SERVICE_TRIGGER_URL_PARAM_KEY = 'tryon';
export const SERVICE_BUTTON_CLASS = 'button-open-dsf-app';
